import {bugsnagClient} from '~/utils/Bugsnag/client'

export type NotifyBugsnagOpts<CaughtErrorType = unknown> = {
  caughtError?: CaughtErrorType
  // TODO: this team is not used, we should implement it
  team?: 'creative-products'
  metadata?: Record<string, unknown>
  groupingHash?: string
}

const BUGSNAG_CAUGHT_ERROR_TAG = 'Caught Error'
const BUGSNAG_CUSTOM_METADATA_TAG = 'Custom Metadata'

/**
 * NOTE: mercury-web's implementation of this function is much more complex
 * but we don't need most of the features
 */
export function notifyBugsnag<CaughtErrorType = unknown>(
  errorMessage: string,
  opts?: NotifyBugsnagOpts<CaughtErrorType>
): void {
  if (!bugsnagClient) return

  const {caughtError, metadata, groupingHash} = opts || {}

  bugsnagClient.notify(errorMessage, event => {
    if (caughtError) {
      event.addMetadata(BUGSNAG_CAUGHT_ERROR_TAG, {
        error: caughtError,
        errorClass: (caughtError as unknown as object)?.constructor?.name,
      })
    }

    if (metadata) {
      event.addMetadata(BUGSNAG_CUSTOM_METADATA_TAG, metadata)
    }

    if (groupingHash) {
      event.groupingHash = groupingHash
    }
  })
}
